export const calendarGoogleList = {
    GET_GOOGLE_LIST_CALENDAR: "GET_GOOGLE_LIST_CALENDAR",
    GET_GOOGLE_LIST_CALENDAR_SUCCESS : "GET_GOOGLE_LIST_CALENDAR_SUCCESS",
    GET_GOOGLE_LIST_CALENDAR_NULL : "GET_GOOGLE_LIST_CALENDAR_NULL",
    GET_GOOGLE_LIST_CALENDAR_ERROR : "GET_GOOGLE_LIST_CALENDAR_ERROR",
}